import React, { useState, useEffect } from 'react'
import { X } from 'react-feather'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { useSkin } from '@hooks/useSkin'
import { useDispatch } from 'react-redux'
import LivePopup from '../LandingPage/LivePopupPage/LivePopup'
import UpdatePassword from './UpdatePassword'
import SpecificCategories from '../UserPortal/Coupon&Vouchers/AppliedTo/SpecificCategories'
import WholeStore from '../UserPortal/Coupon&Vouchers/AppliedTo/WholeStore'
import SpecificProducts from '../UserPortal/Coupon&Vouchers/AppliedTo/SpecificProducts'
import WishlistForm from '../UserPortal/Wishlist/AllWishlist/WishlistForm'
import TransactionHistoryDetails from '../UserPortal/GiftCards/TransactionHistoryDetails'
import WithdrawApplication from '../UserPortal/JobApplications/WithdrawApplication'
import CancelOrder from '../UserPortal/Orders/CancelOrder/CancelOrder'

const PopupModal = ({ company_id, open, name, setModal, tableData, setTableData }) => {

  // console.log('company_id:', company_id);
  //   console.log('open:', open);
  //   console.log('name:', name);
  //   console.log('setModal:', setModal);
  //   console.log('tableData:', tableData);
  //   console.log('setTableData:', setTableData);

  const { skin, setSkin } = useSkin()

  const [inputComponent, setInputComponent] = useState("")
  const [nameModalOpen, setNameModalOpen] = useState("")
  const [inputModal, setInputModal] = useState(false)

  const dispatch = useDispatch()

  // console.log('name',name)

  const check = (modalName) => {

    console.log('modalName', modalName)

    setInputModal(true)
    if (modalName === 'Popup') return <LivePopup tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'User Password') return <UpdatePassword tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Specific Categories') return <SpecificCategories tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Whole Store') return <WholeStore tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Specific Products') return <SpecificProducts tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Create New Wishlist' || modalName === 'Edit Wishlist') return <WishlistForm tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Transaction Details') return <TransactionHistoryDetails tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Withdraw Application') return <WithdrawApplication tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />
    else if (modalName === 'Cancel Order') return <CancelOrder tableData={tableData} setTableData={setTableData} tableForm={true} currentModalName={modalName} setNameModalOpen={setNameModalOpen} inputModal={inputModal} setInputModal={setInputModal} />


  }


  useEffect(() => {
    if (nameModalOpen !== "") {
      setInputComponent(check(nameModalOpen))
    }
  }, [nameModalOpen])

  useEffect(() => {
    if (open) {
      setNameModalOpen(name)

    }
  }, [open])

  const handleSidebarClosed = () => {
    setNameModalOpen("")
    setInputModal(false)
    setModal(false)
    if (name == "Enterprise") {
      // dispatch(packagesData([]));
    }
  }

  const CloseInputBtn = (
    <X
      className="cursor-pointer"
      size={15}
      onClick={() => handleSidebarClosed()}
    />
  )

  const handleInputModal = () => {
    setNameModalOpen("")
    setInputModal(!inputModal)
  }

  return (
    <>
      <div>
        <Modal
          // style={{ borderBottomLeftRadius:'10px', borderBottomRightRadius:'10px'}}
          isOpen={inputModal}
          // toggle={handleInputModal}
          onClosed={handleSidebarClosed}
          className={
            name === 'Popup' ? 'modal-xl' : name === 'User Password' ? 'modal-md'
              : name === 'Specific Categories' ? 'modal-md'
                : name === 'Whole Store' ? 'modal-md'
                  : name === 'Specific Products' ? 'modal-md'
                    : ''
          }
          centered
        >

          {/* <ModalHeader  
                  toggle={handleInputModal}
                >
                </ModalHeader> */}
          <div className="position-relative justify-content-center"
            style={{ display: "flex", backgroundColor: 'white', padding: '.5rem', borderRadius: '100%' }}
            // close={ModalCloseButton(setView)}
            toggle={handleInputModal}
          >
            <h5>{name == 'Popup' ? '' : name}</h5>
          </div>

          <ModalBody className="flex-grow-1" style={{ backgroundColor: 'white', borderRadius: '100%', paddingTop: 0 }}>
            {inputComponent}
          </ModalBody>
        </Modal>
      </div>
    </>
  )
}

export default PopupModal